"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=(t,r=t.length)=>(...e)=>e.length>=r?t(...e):l(t.bind(null,...e),r-e.length);exports.curry=l;
